import _get from 'lodash/get';
import MediaPlayerEvents from '../events/media-player-events';
import PluginReadyMessage from '../comm/message/plugin-ready-message';
import PluginEvents from './plugin-events';

/**
 *
 * @module AbstractPlugin
 * @desc
 * @class AbstractPlugin
 *
 */
class AbstractPlugin {

    /**
     *
     * @constructor
     * @param {PluginConfig} config
     * @param {BehaviorSubject} pluginSubject
     *
     */
    constructor(config, observationCenter) {

        /**
         *
         * @type {PluginConfig}
         *
         */
        this.config = config;


        /**
         *
         * @type {BehaviorSubject}
         *
         */
        this.observationCenter = observationCenter;

        /**
         *
         * @type {MediaPlayer}
         *
         */
        this.mediaPlayer = undefined;

        /**
         *
         * @type {Subscription[]}
         *
         */
        this.subscriptions = [];

        this.subscribe();

    }

    /**
     *
     * @desc subscribe to player data streams
     *
     */
    subscribe() {

        this.subscriptions.push(
            this.observationCenter.playerSubject.subscribe((state) => {

                switch (_get(state, 'type')) {

                    case MediaPlayerEvents.MEDIA_PLAYER_CREATED: {

                        this.setMediaPlayer(state.mediaPlayer);

                        break;

                    }

                }

            })
        );

    }

    /**
     *
     * @desc Sends a PluginReadyMessage event
     *
     */
    pluginReady() {

        this.observationCenter.pluginSubject.next(new PluginReadyMessage(PluginEvents.READY, this));

    }

    /**
     *
     * @desc Sets the mediaPlayer reference on the plugin
     * @param {MediaPlayer} mediaPlayer
     *
     */
    setMediaPlayer(mediaPlayer) {

        this.mediaPlayer = mediaPlayer;

        this.pluginReady();

    }

    /**
     *
     * @desc Release allocated resources
     *
     */
    destroy() {

        this.subscriptions.forEach((subscription) => {

            subscription.unsubscribe();

        });

    }

}

export default AbstractPlugin;
